import { set } from "date-fns";

/**
 * Today's date, at exactly 00:00:00000
 *
 * Useful when manipulating dates without needing to think about time,
 * especially in tests where we need to compare dates without the time the test
 * takes causing us problems.
 */
const now = new Date();
export const today = set(
  now,
  /*eslint-disable sort-keys */ {
    hours: now.getTimezoneOffset() < 0 ? 1 : 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  } /*eslint-enable sort-keys */,
);
